// blakfy-cookie/src/i18n/translations/zh-TW.js — Traditional Chinese translations

export default {
  title: "Cookie 偏好設定",
  intro: "本網站使用 Cookie 來改善您的體驗。詳情請查看我們的 Cookie 政策。",
  policyLink: "Cookie 政策",
  acceptAll: "接受全部",
  rejectAll: "拒絕全部",
  preferences: "偏好設定",
  save: "儲存選擇",
  close: "關閉",
  cat: {
    essential: { title: "必要 Cookie", desc: "網站基本功能所必需，無法停用。", always: "始終啟用" },
    analytics: { title: "分析 Cookie", desc: "用於收集匿名訪問統計資料。" },
    marketing: { title: "行銷 Cookie", desc: "用於個人化廣告和再行銷。" },
    functional: { title: "功能 Cookie", desc: "用於記住語言、主題等偏好設定。" },
  },
  placeholder: {
    title: "內容已被封鎖",
    desc: "您需要允許 {category} Cookie 才能檢視此內容。",
    cta: "允許",
  },
  tabs: {
    categories: "Categories",
    services: "Services",
    about: "About",
  },
  service: {
    description: "Description",
    processor: "Data Processor",
    address: "Address",
    dpo: "DPO Contact",
    purposes: "Purposes",
    technologies: "Technologies Used",
    dataCollected: "Data Collected",
    legalBasis: "Legal Basis",
    retention: "Retention Period",
    transferCountries: "Transfer Countries",
    privacyPolicy: "Privacy Policy",
    cookiePolicy: "Cookie Policy",
    legalBasisValues: {
      consent: "Consent (Art. 6 para. 1 s. 1 lit. a GDPR)",
      legitimate_interest: "Legitimate Interest (Art. 6 para. 1 s. 1 lit. f GDPR)",
    },
    noServices: "No services are configured for this site.",
  },
  svcAbout: {
    title: "About this CMP",
    description:
      "This website uses Blakfy Cookie Management Platform (CMP) to manage your consent preferences in compliance with GDPR, KVKK, CCPA and other applicable privacy regulations.",
    version: "Version",
    learnMore: "Learn more at blakfy.com",
  },
};
